import { render, staticRenderFns } from "./chat-status.vue?vue&type=template&id=cd150c90&scoped=true"
import script from "./chat-status.vue?vue&type=script&lang=js"
export * from "./chat-status.vue?vue&type=script&lang=js"
import style0 from "./chat-status.vue?vue&type=style&index=0&id=cd150c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd150c90",
  null
  
)

export default component.exports